// extracted by mini-css-extract-plugin
export default {"msgM":"_4e0bda8e1d"};